export enum productsActionTypes {
    FETCHING_PRODUCTS_START= "FETCHING_PRODUCTS_START",
    FETCHING_PRODUCTS_FAILED= "FETCHING_PRODUCTS_FAILED",
    FETCHING_PRODUCTS_SUCCESS= "FETCHING_PRODUCTS_SUCCESS",
    SET_PRODUCTS= "SET_PRODUCTS",
}

